import { Flex, FlexProps } from "@chakra-ui/react";
import { MARGIN_Y } from "components/Shared/Forms/FormFieldWrapper";

export type InlineFieldsWrapperProps = FlexProps & {
  fieldMinWidth?: string;
  fieldWrapWidth?: string;
  isLabelTruncated?: boolean;
  isLabelWrappable?: boolean;
};

export default function InlineFieldsWrapper({
  children,
  fieldMinWidth = "auto",
  fieldWrapWidth = "8em",
  isLabelTruncated = false,
  isLabelWrappable = false,
  ...rest
}: InlineFieldsWrapperProps) {
  return (
    <Flex
      my={MARGIN_Y}
      gap={MARGIN_Y}
      flexWrap="wrap"
      {...rest}
      sx={{
        ...rest.sx,
        "> .chakra-form-control": {
          my: 0,
          flex: `1 0 ${
            fieldMinWidth === "auto" ? fieldWrapWidth : fieldMinWidth
          }`,
          minW: fieldMinWidth,
          width: "auto",
          "> label":
            (isLabelTruncated && { isTruncated: true }) ||
            (!isLabelWrappable && { whiteSpace: "nowrap" }) ||
            undefined,
        },
      }}
    >
      {children}
    </Flex>
  );
}
